import { render, staticRenderFns } from "./FWMLv2LocatorViz.vue?vue&type=template&id=7650b10b"
import script from "./FWMLv2LocatorViz.vue?vue&type=script&lang=js"
export * from "./FWMLv2LocatorViz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports